import { render, staticRenderFns } from "./FBreakpoints.vue?vue&type=template&id=2f785680&"
import script from "./FBreakpoints.vue?vue&type=script&lang=js&"
export * from "./FBreakpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports